import React, { lazy } from 'react';
export function AboutAuthorSection() {
  return <section className="py-6 px-4 bg-[#0F1827]" data-id="element-4">
      <div className="max-w-3xl mx-auto" data-id="element-5">
        <div className="bg-[#1A2332] border border-[#2A3444] rounded-3xl p-5 md:p-8 shadow-2xl" data-id="element-6">
          <div className="flex flex-col items-center" data-id="element-7">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-full border-4 border-yellow-400 mb-4 overflow-hidden shadow-xl" data-id="element-8">
              <img src="https://cdn.magicpatterns.com/uploads/unyH83UkeG7XVrsTzAwXdk/ingeniero-electrico.jpg" alt="Ing. Fernandes" className="w-full h-full object-cover" loading="lazy" data-id="element-9" />
            </div>

            <h3 className="text-xl md:text-2xl font-bold text-[#F7D060] mb-4 text-center font-[Poppins,_sans-serif]" data-id="element-10">
              Acerca del Ing. Bermudez
            </h3>

            <div className="space-y-4 text-center text-gray-300 text-sm md:text-base max-w-2xl leading-relaxed" data-id="element-11">
              <p data-id="element-12">
                Soy ingeniero electricista, especializado en controles
                eléctricos y automatización, con más de 10 años de experiencia.
                Soy docente y fui{' '}
                <strong className="text-white" data-id="element-13">
                  campeón de WorldSkills Americas
                </strong>
                , una competencia internacional de instalaciones eléctricas.
              </p>
              <p data-id="element-14">
                En esta Guía Práctica he reunido los principales esquemas y
                secretos realistas que utilicé (y sigo utilizando) para instalar
                circuitos de control eléctrico.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}